const svg = (paths, { fill = 'none', size = 'h-5 w-5' } = {}) => (
  `<svg viewBox="0 0 24 24" class="${size}" fill="${fill}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`
);

const HEART = '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/>';

export const icons = {
  heart: (options) => svg(HEART, options),
  heartFilled: (options) => svg(HEART, { ...options, fill: 'currentColor' }),
  eye: (options) => svg('<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>', options),
  download: (options) => svg('<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/>', options),
  arrowRight: (options) => svg('<path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>', options),
  arrowLeft: (options) => svg('<path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/>', options),
  play: (options) => svg('<path d="M6 4l14 8-14 8z"/>', { ...options, fill: 'currentColor' }),
};
